module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/babel-runtime/core-js/object/assign.js
// module id = saYs
// module chunks = 6